import {useMutation, UseMutationResult, useQueryClient} from "@tanstack/react-query";
import {useAuth} from "../../../../../../../utils/contexts/auth-context";
import {CustomAxiosError, useApiCalls} from "../../../../../../../logics/api_config";
import {IOtherDestination} from "../../../../../../../utils/interfaces/my_documents/fiscal_registry/IOtherDestination";


const useApiUpdateOtherDestination = (): UseMutationResult<IOtherDestination, CustomAxiosError, {
    fiscal_registry_id: number | undefined,
    id: number;
    data: any
}, unknown> => {
    const {selectedCompany} = useAuth()

    const {put} = useApiCalls()

    async function doUpdate(company_token: string | undefined,
                            fiscal_registry_id: number | undefined,
                            pk: number | undefined,
                            data: any): Promise<IOtherDestination> {
        try {
            const response = await put(`/api/company/${company_token}/my_documents/fiscal_registry/${fiscal_registry_id}/other_destination/${pk}/`, data);
            return response.data as IOtherDestination;
        } catch (error) {
            throw error;
        }
    }

    return useMutation<IOtherDestination, CustomAxiosError, {
        fiscal_registry_id: number | undefined,
        id: number;
        data: any
    }, unknown>({
        mutationFn: async ({fiscal_registry_id, id, data}) => {
            return await doUpdate(selectedCompany?.company_token, fiscal_registry_id, id, data);
        },
        onSuccess: async (data) => {
            // await queryClient.invalidateQueries({queryKey: ["useApiGetOtherDestination", _fiscal_registry_id, data.id]});
            // await queryClient.invalidateQueries({queryKey: ["useApiGetOtherDestinations", _fiscal_registry_id]});
        },
    });
};


export default useApiUpdateOtherDestination;
